import React from "react";

export const Stats = () => {
  const stats = [
    {
      icon: "fa-solid fa-calendar",
      number: "5+",
      text: "Anos de Experiência"
    },
    {
      icon: "fa-solid fa-circle-check",
      number: "50+",
      text: "Projetos Entregues"
    },
    {
      icon: "fa-solid fa-users",
      number: "30+",
      text: "Clientes Satisfeitos"
    },
    {
      icon: "fa-solid fa-code",
      number: "15+",
      text: "Tecnologias Dominadas"
    }
  ];

  return (
    <div id="stats" className="text-center">
      <div className="container">
        <div className="row">
          {stats.map((stat, i) => (
            <div key={`stat-${i}`} className="col-xs-6 col-md-3">
              <div className="stat-item">
                <i className={stat.icon}></i>
                <h3>{stat.number}</h3>
                <p>{stat.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
